import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { Button, Box } from '@material-ui/core';

import { useDetailButtonContainerStyles } from './styles';
import {
  PRODUCT_DETAIL_TRACKING_MOBILE_ROUTE,
  REPORT_ISSUES,
} from '../../../../../../constants/Routes';
import { showReportIssue } from '../../../../../../constants/Visible';
import { simpleUrl } from '../../../../../../config/paths';

const DetailButtonContainer = ({ ...props }) => {
  const {
    billImage,
    dispatch,
    orderId,
    errorTracking,
    name,
    sku,
    urlNc,
  } = props;
  const classes = useDetailButtonContainerStyles();
  const location = useLocation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      marginTop="27px"
      className={classes.container}
    >
      <Link
        to={{
          pathname: PRODUCT_DETAIL_TRACKING_MOBILE_ROUTE,
          state: {
            dispatch,
            orderId,
            errorTracking,
            name,
            sku,
            prevRoute: name,
          },
        }}
        className={classes.link}
      >
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          data-cy="trackingButtonMobile"
        >
          Seguir mi compra
        </Button>
      </Link>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => window.open(billImage, '_blank')}
        className={classes.button}
      >
        Descargar boleta
      </Button>
      {urlNc ? (
        <Button
          variant="outlined"
          color="secondary"
          disabled={!urlNc}
          onClick={() => window.open(urlNc, '_blank')}
          data-cy="downloadNCButton"
          className={classes.button}
        >
          Descargar nota de crédito
        </Button>
      ) : (
        <React.Fragment>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() =>
              window.open(`${simpleUrl}${sku}#tab-Comentarios`, '_blank')
            }
            className={classes.button}
            data-cy="writeOpinionButton"
          >
            Escribir opinión
          </Button>
        </React.Fragment>
      )}
      {showReportIssue === 'on' && (
        <Link
          to={{
            pathname: REPORT_ISSUES,
            search: `?orderId=${orderId}&sku=${sku}`,
            state: {
              mobile: true,
              product: {
                orderId,
                sku,
              },
              prevRoute: location.pathname,
            },
          }}
          className={classes.link}
        >
          <Button
            variant="outlined"
            color="secondary"
            className={classes.button}
          >
            Reportar inconveniente
          </Button>
        </Link>
      )}
    </Box>
  );
};

DetailButtonContainer.propTypes = {
  billImage: PropTypes.string,
  dispatch: PropTypes.object,
  orderId: PropTypes.number,
  errorTracking: PropTypes.string,
  name: PropTypes.string,
  sku: PropTypes.string,
  urlNc: PropTypes.string,
};

export default DetailButtonContainer;
